import * as PrismicTypes from '@prismicio/types'
import { last } from 'lodash'
import React from 'react'

import { Language } from '../types/Types'
import GeneralPage from '../modules/GeneralPage'
import { getLayoutData, getDocumentByUid, getAllDocumentsByType, getAllPages } from '../utils/prismic/data-helpers'
import { getBreadCrumbs, resolveDocPath } from '../utils/prismic/route-helpers'
import { ICrumb } from '../components/BreadCrumbs'
import { PageDocument } from '../../prismicio-types'

/*
	This file is using Catch all routes embedded into nextjs https://nextjs.org/docs/routing/dynamic-routes#catch-all-routes
	Predefined routes take precedence over dynamic routes, and dynamic routes over catch all routes.
*/

const Index: React.FC<{ page: PageDocument; locale: Language; crumbs: ICrumb[] }> = (props) => {
	return <GeneralPage {...props} />
}

export async function getStaticProps({
	params,
	previewData,
	locale,
}: {
	locale: Language
	previewData: PrismicTypes.Ref
	params: { page: string[] }
}) {
	const { ref } = previewData || {}
	const lastUid = last(params.page)

	const [page, layoutData, allPages] = await Promise.all([
		getDocumentByUid('page', lastUid as string, ref, locale),
		// getPageDataByUid(ref, locale, lastUid as string),
		getLayoutData(ref, locale),
		getAllPages(),
	])

	const crumbs = await getBreadCrumbs(page, allPages)

	return {
		props: {
			page,
			allPages,
			crumbs,
			layoutData: { ...layoutData },
		},
	}
}

export async function getStaticPaths() {
	const pages = await getAllDocumentsByType('page')
	const allPages = await getAllPages()

	const paths = pages.map((page) => {
		return resolveDocPath(page, allPages)
	})

	return {
		paths,
		fallback: false,
	}
}

export default Index
